import { ON_LOAD_NOTIFICATIONS } from "../constants/notifications";

const initialState = [];

export default function (state = initialState, action) {
  return state;
}
